import React from 'react';
import { useState, useEffect } from 'react';
import "./accept.css"


const AcceptInput = (props) => {
   let classNameButton = "forAllTittle";
    let tittle = "";
   const [checked, setChecked] = useState(false);

    const handleChange = (e) => {
       
      setChecked(!checked);
      if(props.onAccept != undefined){
      props.onAccept(checked)}

      if(props.discountAction != undefined){
        props.discountAction(e,props.discount)
      }
    };

    useEffect(()=>
    {
        if(!props.unClickElement){
          setChecked(false)
    }else{
      setChecked(true)
    }},[props.unClickElement])

    if(props.accpetTittle != undefined){
      tittle = props.accpetTittle
    }
 
    return <>

<div className='iconCheckLabel'>
    <div onClick={handleChange} title={tittle} className='iconCheckWrapper'>
    {
        checked?
        <svg xmlns="http://www.w3.org/2000/svg" className="iconChecked" fill="#cc0033"  viewBox="0 0 36 36"><path d="M25 0H7a7 7 0 0 0-7 7v18a7 7 0 0 0 7 7h18a7 7 0 0 0 7-7V7a7 7 0 0 0-7-7zm5 25a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h18a5 5 0 0 1 5 5z"/><path d="m13 20.59-4.29-4.3-1.42 1.42 5 5a1 1 0 0 0 1.41 0l11-11-1.41-1.41z"/></svg>:
        <svg xmlns="http://www.w3.org/2000/svg" className="iconChecked" fill="#cc0033"  viewBox="0 0 36 36"><path d="M25 0H7a7 7 0 0 0-7 7v18a7 7 0 0 0 7 7h18a7 7 0 0 0 7-7V7a7 7 0 0 0-7-7zm5 25a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h18a5 5 0 0 1 5 5z"/></svg>
    } </div>
        <label>{props.label}</label>
    </div>
   
    </>;
    };

export default AcceptInput;
